define('viewModels/privileged/qm/policies/editors/FlowSelectorView',[
    'lib/lodash4',
    'lib/knockout',
    'viewModels/ViewModel',
    'services/featureToggleService',
    'services/architect/flowService',
    'enums/architect/FlowType'
], function (
    _,
    ko,
    ViewModel,
    featureToggleService,
    flowService,
    FlowType) {
    'use strict';

    /**
     * The FlowSelectorView class.
     * @class
     */
    var FlowSelectorView = ViewModel.extend(function (flowObservable, options) {
        var self = this;
        options = options || {};

        self.loading = ko.observable(false);
        self.flowType = ko.observable(options.flowType || FlowType.INBOUNDCALL);
        self.flow = flowObservable;
        self.placeholderText = ko.i18n.renderString("flowSelector.placeholderText");
        /**
         * Get paged flows (using self.flowType() as type filter).
         * 
         * @param  {string} searchTerm
         * @returns {Promise}
         */
        self.getFlows = function (searchTerm) {
            var flowType = self.flowType();
            var flowSearchParms = {
                pageSize: 100, 
                type: flowType, 
                name: "*" + searchTerm + "*",
                publishVersionId: "*" // gets only published versions
            };
            return featureToggleService.getFeatureToggle('authorization.division.management').then(function (isOn) {
                if (isOn) {
                    return flowService.getBrief.page(flowSearchParms);
                } else {
                    return flowService.get.page(flowSearchParms);
                }
            }).then(function (flowResponse) {
                return flowResponse.entities || [];
            });
        };

        if (_.isArray(self.flow())) {
            self.flow.extend({ deepComparer: true, minLength: { params: 1, message: "flowSelector.noFlowSelected" } });
        } else {
            self.flow.extend({ required: true });
        }
    }, true /* pass args to extended class */);

    return FlowSelectorView;
});

